// @ts-nocheck
import { createSlice } from '@reduxjs/toolkit';

const whitelistSlice = createSlice({
  name: 'whitelist',
  initialState: {
    filtersSuffix: [
      '',
      '__in',
      '__gte',
      '__lte',
      '__range',
      '__contains',
      '__contains_ne',
      '__startswith',
      '__endswith',
      '__intext',
      '__ne',
      '__cidr_contains',
      '__cidr_contained_by',
      '__overlap',
      '__overlap_ne',
      '__cidr_contained_by_array',
      '__isnull=True',
      '__isnull=False'
    ]
  },
  reducers: {
    addValidFilterSuffix(state, { payload }) {
      state.filtersSuffix = [...state.filtersSuffix, payload];
    }
  }
});

const { actions, reducer } = whitelistSlice;
export const { addValidFilterSuffix } = actions;
export default reducer;
